import type { NextRequest } from 'next/server'

/**
 * Adds the language code to the URL pathname of a Next.js request.
 * @param lng - The language code to add to the URL pathname.
 * @param request - The Next.js request object.
 * @returns A new URL object with the updated pathname.
 */
export function addLanguageToUrl(lng: string, request: NextRequest) {
  const originalUrl = new URL(request.url)
  const newPathname = `/${lng}${request.nextUrl.pathname}`

  return new URL(
    newPathname + originalUrl.search + originalUrl.hash,
    originalUrl.origin
  )
}
